const config = {
    version: '1.8.1',
    MAX_ATTACHMENT_SIZE: 1000000,
    sites: [
        {
            title: 'North Platte Post',
            value: 'northplatte',
            url: 'https://northplattepost.com',
            native_ad_location_id: '9cbc7316-a2d7-44a5-afd7-1288f85b96e0',  // Probably set up in Google Ad Manager
            firebaseConfig: {
                apiKey: 'AIzaSyA6fr-7nmn-tRWkpRkt846y2OUM3LzfGX4',  // Browser key, located under API Keys & Services->Credentials in the Google project
                authDomain: 'north-platte-mobile-app.firebaseapp.com',  // Also under credentials, this is set in Web client->Authorized JavaScript origins->URIs
                databaseURL: 'https://north-platte-mobile-app.firebaseio.com',
                projectId: 'north-platte-mobile-app',
                storageBucket: 'north-platte-mobile-app.appspot.com',
                messagingSenderId: '372575400749',  // API Keys & Services->Credentials->Oath 2.0 Client IDS->Client ID
                appId: '1:372575400749:web:a2ddba0876e8584b00d9a4',  // In Firebase, Project Settings, Your Apps, App ID
                measurementId: 'G-S1S1PH4S3N',
            },
        },
        {
            title: 'Sand Hills Post',
            value: 'sandhills',
            url: 'https://sandhillspost.dev',
            native_ad_location_id: '',  // Stored in nativelocations table, probably set up in Google Ad Manager
            firebaseConfig: {
                apiKey: 'AIzaSyAdAIunt3Qaedl3bW-q3fZFL6ZopBeiwVI',  // Browser key, located under API Keys & Services->Credentials in the Google project
                authDomain: 'sandhills-post-mobile-app.firebaseapp.com',  // Also under credentials, this is set in Web client->Authorized JavaScript origins->URIs
                databaseURL: 'https://sandhills-post-mobile-app.firebaseio.com',
                projectId: 'sandhills-post-mobile-app',
                storageBucket: 'sandhills-post-mobile-app.appspot.com',
                messagingSenderId: '248948293637', // API Keys & Services->Credentials->Oath 2.0 Client IDS->Client ID
                appId: '1:372575400749:web:a2ddba0876e8584b00d9a4',  // In Firebase, Project Settings, Your Apps, App ID THIS IS CURRENTLY SET TO NORTH PLATTE
                measurementId: 'G-S1S1PH4S3N',  // ALSO SET TO NORTH PLATTE
            },
        },
        {
            title: 'Maryville Post',
            value: 'maryville',
            url: 'https://maryvillepost.dev',
            native_ad_location_id: '',  // Stored in nativelocations table, probably set up in Google Ad Manager
            firebaseConfig: {
                apiKey: 'AIzaSyDixB4gW46_H2Ldzm6lRcnFctyD3NsxJNU', // Browser key, located under API Keys & Services->Credentials in the Google project
                authDomain: 'maryville-post-mobile.firebaseapp.com',  // Also under credentials, this is set in Web client->Authorized JavaScript origins->URIs
                databaseURL: 'https://maryville-post-mobile.firebaseio.com',
                projectId: 'maryville-post-mobile',
                storageBucket: 'maryville-post-mobile.appspot.com',
                messagingSenderId: '',
                appId: '1:68335519849:web:16fcd472cd022a2db27af8', // In Firebase, Project Settings, Your Apps, App ID THIS IS CURRENTLY SET TO ST JOE since there's no mobile app
                measurementId: 'G-0N5V6V03WR',  // ALSO SET TO ST JOE since there's no mobile app
            },
        },
        {
            title: 'St Joseph Post',
            value: 'stjoseph',
            url: 'https://stjosephpost.com',
            native_ad_location_id: '58dc4002-f61b-44be-a5c4-233fd8266e83',
            firebaseConfig: {
                apiKey: 'AIzaSyBix5dcEXqdl_Km4hkq6BM5CDqokVdDGjk',
                authDomain: 'st-joseph-post-mobile.firebaseapp.com',
                databaseURL: 'https://st-joseph-post-mobile.firebaseio.com',
                projectId: 'st-joseph-post-mobile',
                storageBucket: 'st-joseph-post-mobile.appspot.com',
                messagingSenderId: '68335519849',
                appId: '1:68335519849:web:16fcd472cd022a2db27af8',
                measurementId: 'G-0N5V6V03WR',
            },
        },
        {
            title: 'Panhandle Post',
            value: 'panhandle',
            url: 'https://panhandlepost.com',
            native_ad_location_id: '935574b1-3550-4ca4-981e-ca5a96bef0d7',
            firebaseConfig: {
                apiKey: 'AIzaSyD-i2HyZmx7cUF7WE5vWGR72wOB8T4EA5U',
                authDomain: 'panhandle-post-mobile.firebaseapp.com',
                databaseURL: 'https://panhandle-post-mobile.firebaseio.com',
                projectId: 'panhandle-post-mobile',
                storageBucket: 'panhandle-post-mobile.appspot.com',
                messagingSenderId: '722528806197',
                appId: '1:722528806197:web:0c4a02cd06632e026c587c',
                measurementId: 'G-MXK007V2C8',
            },
        },
        {
            title: 'Salina Post',
            value: 'salina',
            url: 'https://salinapost.com',
            native_ad_location_id: '3ee2367d-01b1-4b71-a757-cea168eba4d8',
            firebaseConfig: {
                apiKey: 'AIzaSyCm22DKOv5OD_x8soZRzfxLhu-VZDLTXLM',
                authDomain: 'salina-post-mobile-app.firebaseapp.com',
                databaseURL: 'https://salina-post-mobile-app.firebaseio.com',
                projectId: 'salina-post-mobile-app',
                storageBucket: 'salina-post-mobile-app.appspot.com',
                messagingSenderId: '872842117213',
                appId: '1:872842117213:web:5c41f350e634719b8b4db4',
                measurementId: 'G-MZ76F28XZF',
            },
        },
        {
            title: 'JC Post',
            value: 'jc',
            url: 'https://jcpost.com',
            native_ad_location_id: 'eefc9d98-df56-4a9e-802b-ecd7c43a8c45',
            firebaseConfig: {
                apiKey: 'AIzaSyBaP55X5pUQ-X-J8xru1vwTZF-6ZSGRXXk',
                authDomain: 'jc-post-mobile.firebaseapp.com',
                databaseURL: 'https://jc-post-mobile.firebaseio.com',
                projectId: 'jc-post-mobile',
                storageBucket: 'jc-post-mobile.appspot.com',
                messagingSenderId: '552634921029',
                appId: '1:552634921029:web:3159ed11fa46ba5257f32c',
                measurementId: 'G-YV3CNJE72J',
            },
        },
        {
            title: 'Little Apple Post',
            value: 'littleapple',
            url: 'https://littleapplepost.com',
            native_ad_location_id: '39fc542f-e9d7-49ed-87d6-c303e07a9d74',
            firebaseConfig: {
                apiKey: 'AIzaSyDKnH5tw9LMy7ESJPzc4n409R0PeknShHo',
                authDomain: 'little-apple-post-mobile.firebaseapp.com',
                databaseURL: 'https://little-apple-post-mobile.firebaseio.com',
                projectId: 'little-apple-post-mobile',
                storageBucket: 'little-apple-post-mobile.appspot.com',
                messagingSenderId: '575748022554',
                appId: '1:575748022554:web:c87234ceb33daa6bff4ca3',
                measurementId: 'G-5D81G0H401',
            },
        },
        {
            title: 'Hays Post',
            value: 'hays',
            url: 'https://hayspost.com',
            native_ad_location_id: '870eda59-3703-4621-9fda-0312f1c468f6',
            firebaseConfig: {
                apiKey: 'AIzaSyCrrfs1amT2kbHh0WKjF1LYPFyo9UNNdZg',
                authDomain: 'hays-post-mobile-app.firebaseapp.com',
                databaseURL: 'https://hays-post-mobile-app.firebaseio.com',
                projectId: 'hays-post-mobile-app',
                storageBucket: 'hays-post-mobile-app.appspot.com',
                messagingSenderId: '883693385791',
                appId: '1:883693385791:web:1b3839e03e43eb7e70a08a',
                measurementId: 'G-T2YHCXWJ9E',
            },
        },
        {
            title: 'Great Bend Post',
            value: 'greatbend',
            url: 'https://greatbendpost.com',
            native_ad_location_id: 'c581ea69-271f-4ac4-8c3d-d1511c553f3d',
            firebaseConfig: {
                apiKey: 'AIzaSyD0-ue46Ro9njWfyJ8rjjJUjfNFxscren4',
                authDomain: 'great-bend-post-mobile.firebaseapp.com',
                databaseURL: 'https://great-bend-post-mobile.firebaseio.com',
                projectId: 'great-bend-post-mobile',
                storageBucket: 'great-bend-post-mobile.appspot.com',
                messagingSenderId: '598410527897',
                appId: '1:598410527897:web:fa2204bc7838f7a8e3a408',
                measurementId: 'G-S174N3BK1L',
            },
        },
        {
            title: 'Hutchinson Post',
            value: 'hutch',
            url: 'https://hutchpost.com',
            native_ad_location_id: '3456bf34-6f00-45d8-8ada-0c465a6a7274',
            firebaseConfig: {
                apiKey: 'AIzaSyCm6yPFhwARU-rAbTJuMGQHvyFQ5uo9-OA',
                authDomain: 'hutch-post-mobile-app.firebaseapp.com',
                databaseURL: 'https://hutch-post-mobile-app.firebaseio.com',
                projectId: 'hutch-post-mobile-app',
                storageBucket: 'hutch-post-mobile-app.appspot.com',
                messagingSenderId: '1000604730113',
                appId: '1:1000604730113:web:5732361c4812ef3292d100',
                measurementId: 'G-TCJF27XW38',
            },
        },
    ],
    s3: {
        REGION: 'us-east-1',
        BUCKET: 'post-api-prod-attachmentsbucket-1uy74myu9sw9h',
        URL:
            'https://s3.amazonaws.com/post-api-prod-attachmentsbucket-1uy74myu9sw9h/public/',
        CDN: 'https://media.eaglewebservices.com/public/',
    },
    cognito: {
        REGION: 'us-east-1',
        USER_POOL_ID: 'us-east-1_LNh6igAvf',
        APP_CLIENT_ID: '1f97s0ngtpl7chd0kjan5280hl',
        IDENTITY_POOL_ID: 'us-east-1:7d809c2b-2249-486a-a234-6ab9f9831ce8',
    },
    imageBasePath: 'https://media.eaglewebservices.com/public/',
    staticAdLocations: [
        {
            title: 'Home Push Down Ad',
            slug: 'homePushDownAd',
        },
        {
            title: 'Home Popup',
            slug: 'homePopup',
        },
        {
            title: 'Header Top Banner',
            slug: 'headerTopBanner',
        },
        {
            title: 'Home Below Featured / Top of inner post',
            slug: 'homeBelowFeatured',
        },
        {
            title: 'Home Left Inner Stories',
            slug: 'homeLeftColumn',
        },
        {
            title: 'Home Right Inner Stories',
            slug: 'homeRightColumn',
        },
        {
            title: 'Home Sidebar',
            slug: 'homeSidebar',
        },
        {
            title: 'Inner Page Sidebar',
            slug: 'innerPageSidebar',
        },
        {
            title: 'Obituary Banner',
            slug: 'obituaryBanner',
        },
        {
            title: 'Home Sports',
            slug: 'homeSports',
        },
        {
            title: 'Home Fourth Category',
            slug: 'homeFourthCategory',
        },
        {
            title: 'Inner Page Above Title',
            slug: 'innerPageAboveTitle',
        },
        {
            title: 'Coronavirus Update',
            slug: 'coronavirusUpdate',
        },
        {
            title: 'Below Post (Mobile Only)',
            slug: 'belowPost',
        },
    ],
    staticPostCategories: [
        {
            title: 'Local',
            slug: 'local',
        },
        {
            title: 'State',
            slug: 'state',
        },
        {
            title: 'Arrests',
            slug: 'arrests',
        },
        {
            title: 'Obituaries',
            slug: 'obituaries',
        },
        {
            title: 'Sports',
            slug: 'sports',
        },
    ],
}

export default config
